module.exports = __webpack_public_path__ + "img/genesis-drop-bubble-1-bg.cc8105d6.png";